import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=3cc5248d&scoped=true&"
import script from "./ArticleEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEdit.vue?vue&type=style&index=0&id=3cc5248d&prod&lang=scss&"
import style1 from "./ArticleEdit.vue?vue&type=style&index=1&id=3cc5248d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc5248d",
  null
  
)

export default component.exports